var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.onClick}},[_c('ChrevronDown',{attrs:{"width":40,"iconColor":'rgba(15,28,112,1)'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }